export const dashboardTooltipText = {
  visited: [
    "Total number of website and app visitors during the selected period and country.",
    "Percentage change compared to the previous equivalent period.",
  ],
  registered: [
    "Total number of accounts created by visitors through the website and app during the selected period.",
    "Percentage change compared to the previous equivalent period.",
  ],
  companySetup: [
    "Total number of accounts that completed their store business details (VAT number, CR number and address) during the selected period.",
    "Percentage change compared to the previous equivalent period.",
  ],
  firstProduct: [
    "Total number of accounts that created  first product during the selected period.",
    "Percentage change compared to the previous equivalent period.",
  ],
  firstInvoice: [
    "Total number of accounts that completed their first invoice during the selected period.",
    "Percentage change compared to the previous equivalent period.",
  ],
  trialled: [
    "Total number of accounts that started a trial during the selected period.",
    "Percentage change compared to the previous equivalent period.",
  ],
  subscribed: [
    "Total number of accounts that subscribed during the selected period.",
    "Percentage change compared to the previous equivalent period.",
  ],
  appClicks: [
    "Total number of clicks on the app download link from the website during the selected period.",
    "Percentage change compared to the previous equivalent period.",
  ],
};

export const options = [
  { lable: "Today", value: "Today" },
  { lable: "Yesterday", value: "Yesterday" },
  { lable: "This Week", value: "ThisWeek" },
  { lable: "Last Week", value: "LastWeek" },
  { lable: "Last 7 Days", value: "Last7Days" },
  { lable: "This Month", value: "ThisMonth" },
  { lable: "Last Month", value: "LastMonth" },
  { lable: "Last 30 Days", value: "Last30Days" },
  { lable: "This Quarter", value: "ThisQuarter" },
  { lable: "Last Quarter", value: "LastQuarter" },
  { lable: "Last 90 Days", value: "Last90Days" },
  { lable: "This Year", value: "ThisYear" },
  { lable: "Last Year", value: "LastYear" },
  { lable: "Custom Range", value: "CustomRange" },
];
